import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';

const rootElement = document.getElementById('root');

if (rootElement !== null) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <App />
    );
} else {
    console.error("Root element not found");
}
